document.addEventListener('DOMContentLoaded', function() {
  const mappings = [
    { id: 'sfw-cards', product: '.product-info.product-40cards-safe' },
    { id: 'nsfw-cards', product: '.product-info.product-40cards-lewd' },
    { id: 'both-cards', product: '.product-info.product-40cards-both' }
  ];

  const inputs = mappings.map(m => document.getElementById(m.id)).filter(Boolean);

  inputs.forEach((input, index) => {
    const product = document.querySelector(mappings[index].product);

    input.addEventListener('click', function() {
      const wasChecked = this.checked; // state *before* browser toggle

      // Allow browser to toggle naturally, but adjust after a short delay
      setTimeout(() => {
        // After browser toggles
        if (this.checked) {

          let counter = document.getElementById("counter-cart");
          let curC = parseInt(counter.textContent, 10) || 0;
          let nextC = curC;

          let totalCartEl = document.querySelector('#total-cart');
          let priceEl;
          let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
          let itemPrice = 0;
          let newTotal = currentTotal;
        
          if (document.getElementById('cart-waifu-cards-safe').classList.contains('show')) {
            document.querySelector(`#cart-waifu-cards-safe`)?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector(`#cart-waifu-cards-safe .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          }
   
          if (document.getElementById('cart-waifu-cards-ecchi').classList.contains('show')) {
            document.querySelector(`#cart-waifu-cards-ecchi`)?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector(`#cart-waifu-cards-ecchi .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          }

          if (document.getElementById('cart-waifu-cards-both').classList.contains('show')) {
            document.querySelector(`#cart-waifu-cards-both`)?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector(`#cart-waifu-cards-both .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          }
       
          counter.textContent = nextC;
          totalCartEl.textContent = '$' + newTotal.toFixed(2)

          // Uncheck all others and remove their .active
          mappings.forEach(({ id, product: selector }) => {
            const cb = document.getElementById(id);
            const el = document.querySelector(selector);
            if (cb && cb !== this) cb.checked = false;
            if (el && cb !== this) el.classList.remove('active');
          });

          // Add .active to the selected product
          if (product) product.classList.add('active');

          curC = parseInt(counter.textContent, 10) || 0;
          currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;

          if ( index == 0 ) {
            document.querySelector(`#cart-waifu-cards-safe`)?.classList.add("show");
            nextC = Math.max(1, curC + 1);
            priceEl = document.querySelector(`#cart-waifu-cards-safe .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal + itemPrice;
          } else if ( index == 1 ) {
            document.querySelector(`#cart-waifu-cards-ecchi`)?.classList.add("show");
            nextC = Math.max(1, curC + 1);
            priceEl = document.querySelector(`#cart-waifu-cards-ecchi .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal + itemPrice;
          } else if ( index == 2 ) {
            document.querySelector(`#cart-waifu-cards-both`)?.classList.add("show");
            nextC = Math.max(1, curC + 1);
            priceEl = document.querySelector(`#cart-waifu-cards-both .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal + itemPrice;
          }
          counter.textContent = nextC;
          totalCartEl.textContent = '$' + newTotal.toFixed(2)

        } else {
          // If user clicked an already checked one → deselect it
          if (product) product.classList.remove('active');

          let counter = document.getElementById("counter-cart");
          let curC = parseInt(counter.textContent, 10) || 0;
          let nextC = curC;

          let totalCartEl = document.querySelector('#total-cart');
          let priceEl;
          let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
          let itemPrice = 0;
          let newTotal = currentTotal;

          if ( index == 0 ) {
            document.querySelector(`#cart-waifu-cards-safe`)?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector(`#cart-waifu-cards-safe .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          } else if ( index == 1 ) {
            document.querySelector(`#cart-waifu-cards-ecchi`)?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector(`#cart-waifu-cards-ecchi .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          } else if ( index == 2 ) {
            document.querySelector(`#cart-waifu-cards-both`)?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector(`#cart-waifu-cards-both .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          }
          counter.textContent = nextC;
          totalCartEl.textContent = '$' + newTotal.toFixed(2)


        }

        const selectors = [
           '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-may',
            '.product-info.product-wcc-june',
            '.product-info.product-wcc-july',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }


      }, 0);
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const mappings = [
    { id: 'sfw-binder', product: '.product-info.product-binder-safe' },
    { id: 'nsfw-binder', product: '.product-info.product-binder-lewd' },
    { id: 'both-binder', product: '.product-info.product-binder-both' }
  ];

  const inputs = mappings.map(m => document.getElementById(m.id)).filter(Boolean);

  inputs.forEach((input, index) => {
    const product = document.querySelector(mappings[index].product);

    input.addEventListener('click', function() {
      const wasChecked = this.checked; // state before browser toggles

      // Wait for browser toggle to complete
      // Allow browser to toggle naturally, but adjust after a short delay
      setTimeout(() => {
        // After browser toggles
        if (this.checked) {

          let counter = document.getElementById("counter-cart");
          let curC = parseInt(counter.textContent, 10) || 0;
          let nextC = curC;

          let totalCartEl = document.querySelector('#total-cart');
          let priceEl;
          let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
          let itemPrice = 0;
          let newTotal = currentTotal;
        
          if (document.getElementById('cart-binder-safe').classList.contains('show')) {
            document.querySelector(`#cart-binder-safe`)?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector(`#cart-binder-safe .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          }
   
          if (document.getElementById('cart-binder-ecchi').classList.contains('show')) {
            document.querySelector(`#cart-binder-ecchi`)?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector(`#cart-binder-ecchi .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          }

          if (document.getElementById('cart-binder-both').classList.contains('show')) {
            document.querySelector(`#cart-binder-both`)?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector(`#cart-binder-both .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          }
       
          counter.textContent = nextC;
          totalCartEl.textContent = '$' + newTotal.toFixed(2)

          // Uncheck all others and remove their .active
          mappings.forEach(({ id, product: selector }) => {
            const cb = document.getElementById(id);
            const el = document.querySelector(selector);
            if (cb && cb !== this) cb.checked = false;
            if (el && cb !== this) el.classList.remove('active');
          });

          // Add .active to the selected product
          if (product) product.classList.add('active');

          curC = parseInt(counter.textContent, 10) || 0;
          currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;

          if ( index == 0 ) {
            document.querySelector(`#cart-binder-safe`)?.classList.add("show");
            nextC = Math.max(1, curC + 1);
            priceEl = document.querySelector(`#cart-binder-safe .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal + itemPrice;
          } else if ( index == 1 ) {
            document.querySelector(`#cart-binder-ecchi`)?.classList.add("show");
            nextC = Math.max(1, curC + 1);
            priceEl = document.querySelector(`#cart-binder-ecchi .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal + itemPrice;
          } else if ( index == 2 ) {
            document.querySelector(`#cart-binder-both`)?.classList.add("show");
            nextC = Math.max(1, curC + 1);
            priceEl = document.querySelector(`#cart-binder-both .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal + itemPrice;
          }
          counter.textContent = nextC;
          totalCartEl.textContent = '$' + newTotal.toFixed(2)

        } else {
          // If user clicked an already checked one → deselect it
          if (product) product.classList.remove('active');

          let counter = document.getElementById("counter-cart");
          let curC = parseInt(counter.textContent, 10) || 0;
          let nextC = curC;

          let totalCartEl = document.querySelector('#total-cart');
          let priceEl;
          let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
          let itemPrice = 0;
          let newTotal = currentTotal;

          if ( index == 0 ) {
            document.querySelector(`#cart-binder-safe`)?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector(`#cart-binder-safe .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          } else if ( index == 1 ) {
            document.querySelector(`#cart-binder-ecchi`)?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector(`#cart-binder-ecchi .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          } else if ( index == 2 ) {
            document.querySelector(`#cart-binder-both`)?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector(`#cart-binder-both .qty-col h3[data-price]`);
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          }
          counter.textContent = nextC;
          totalCartEl.textContent = '$' + newTotal.toFixed(2)

          const selectors = [
           '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-may',
            '.product-info.product-wcc-june',
            '.product-info.product-wcc-july',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }

        }
      }, 0);
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const mappings = [
    { id: 'sfw-double', product: '.product-info.product-double-safe' },
    { id: 'both-double', product: '.product-info.product-double-both' }
  ];

  const inputs = mappings.map(m => document.getElementById(m.id)).filter(Boolean);

  inputs.forEach((input, index) => {
    const product = document.querySelector(mappings[index].product);

    input.addEventListener('click', function() {
      setTimeout(() => {
        if (this.checked) {

          let counter = document.getElementById("counter-cart");
          let curC = parseInt(counter.textContent, 10) || 0;
          let nextC = curC;

          let totalCartEl = document.querySelector('#total-cart');
          let priceEl;
          let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
          let itemPrice = 0;
          let newTotal = currentTotal;
        
          if (document.getElementById('cart-double-safe').classList.contains('show')) {
            document.querySelector('#cart-double-safe')?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector('#cart-double-safe .qty-col h3[data-price]');
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          }
   
          if (document.getElementById('cart-double-both').classList.contains('show')) {
            document.querySelector('#cart-double-both')?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector('#cart-double-both .qty-col h3[data-price]');
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          }
       
          counter.textContent = nextC;
          totalCartEl.textContent = '$' + newTotal.toFixed(2);

          mappings.forEach(({ id, product: selector }) => {
            const cb = document.getElementById(id);
            const el = document.querySelector(selector);
            if (cb && cb !== this) cb.checked = false;
            if (el && cb !== this) el.classList.remove('active');
          });

          if (product) product.classList.add('active');

          curC = parseInt(counter.textContent, 10) || 0;
          currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;

          if (index == 0) {
            document.querySelector('#cart-double-safe')?.classList.add("show");
            nextC = Math.max(1, curC + 1);
            priceEl = document.querySelector('#cart-double-safe .qty-col h3[data-price]');
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal + itemPrice;
          } else if (index == 1) {
            document.querySelector('#cart-double-both')?.classList.add("show");
            nextC = Math.max(1, curC + 1);
            priceEl = document.querySelector('#cart-double-both .qty-col h3[data-price]');
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal + itemPrice;
          }

          counter.textContent = nextC;
          totalCartEl.textContent = '$' + newTotal.toFixed(2);

        } else {
          if (product) product.classList.remove('active');

          let counter = document.getElementById("counter-cart");
          let curC = parseInt(counter.textContent, 10) || 0;
          let nextC = curC;

          let totalCartEl = document.querySelector('#total-cart');
          let priceEl;
          let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
          let itemPrice = 0;
          let newTotal = currentTotal;

          if (index == 0) {
            document.querySelector('#cart-double-safe')?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector('#cart-double-safe .qty-col h3[data-price]');
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          } else if (index == 1) {
            document.querySelector('#cart-double-both')?.classList.remove("show");
            nextC = Math.max(1, curC - 1);
            priceEl = document.querySelector('#cart-double-both .qty-col h3[data-price]');
            itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
            newTotal = currentTotal - itemPrice;
          }

          counter.textContent = nextC;
          totalCartEl.textContent = '$' + newTotal.toFixed(2);

          const selectors = [
            '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-may',
            '.product-info.product-wcc-june',
            '.product-info.product-wcc-july',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
          ];

          const anyActive = selectors.some(sel =>
            document.querySelector(sel)?.classList.contains('active')
          );

          if (anyActive) {
            document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
          } else {
            document.querySelector('#checkout-btn').textContent = "I'll Leave";
          }
        }
      }, 0);
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('wcc-september');
  const product = document.querySelector('.product-info.product-wcc-september');


  if (!checkbox || !product) return;

  checkbox.addEventListener('click', function() {
    setTimeout(() => {
      if (this.checked) {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-september`)?.classList.add("show");
        nextC = Math.max(1, curC + 1);
        priceEl = document.querySelector(`#cart-wcc-september .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal + itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.add('active');
      } else {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-september`)?.classList.remove("show");
        nextC = Math.max(1, curC - 1);
        priceEl = document.querySelector(`#cart-wcc-september .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal - itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.remove('active');

      }

      const selectors = [
          '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-may',
            '.product-info.product-wcc-june',
            '.product-info.product-wcc-july',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }

    }, 0);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('wcc-october');
  const product = document.querySelector('.product-info.product-wcc-october');


  if (!checkbox || !product) return;

  checkbox.addEventListener('click', function() {
    setTimeout(() => {
      if (this.checked) {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-october`)?.classList.add("show");
        nextC = Math.max(1, curC + 1);
        priceEl = document.querySelector(`#cart-wcc-october .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal + itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.add('active');
      } else {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-october`)?.classList.remove("show");
        nextC = Math.max(1, curC - 1);
        priceEl = document.querySelector(`#cart-wcc-october .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal - itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.remove('active');

      }

      const selectors = [
          '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-may',
            '.product-info.product-wcc-june',
            '.product-info.product-wcc-july',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }

    }, 0);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('wcc-november');
  const product = document.querySelector('.product-info.product-wcc-november');


  if (!checkbox || !product) return;

  checkbox.addEventListener('click', function() {
    setTimeout(() => {
      if (this.checked) {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-november`)?.classList.add("show");
        nextC = Math.max(1, curC + 1);
        priceEl = document.querySelector(`#cart-wcc-november .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal + itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.add('active');
      } else {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-november`)?.classList.remove("show");
        nextC = Math.max(1, curC - 1);
        priceEl = document.querySelector(`#cart-wcc-november .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal - itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.remove('active');

      }

      const selectors = [
          '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-may',
            '.product-info.product-wcc-june',
            '.product-info.product-wcc-july',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }

    }, 0);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('wcc-december');
  const product = document.querySelector('.product-info.product-wcc-december');


  if (!checkbox || !product) return;

  checkbox.addEventListener('click', function() {
    setTimeout(() => {
      if (this.checked) {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-december`)?.classList.add("show");
        nextC = Math.max(1, curC + 1);
        priceEl = document.querySelector(`#cart-wcc-december .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal + itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.add('active');
      } else {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-december`)?.classList.remove("show");
        nextC = Math.max(1, curC - 1);
        priceEl = document.querySelector(`#cart-wcc-december .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal - itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.remove('active');

      }

      const selectors = [
          '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-may',
            '.product-info.product-wcc-june',
            '.product-info.product-wcc-july',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }

    }, 0);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('wcc-january');
  const product = document.querySelector('.product-info.product-wcc-january');


  if (!checkbox || !product) return;

  checkbox.addEventListener('click', function() {
    setTimeout(() => {
      if (this.checked) {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-january`)?.classList.add("show");
        nextC = Math.max(1, curC + 1);
        priceEl = document.querySelector(`#cart-wcc-january .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal + itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.add('active');
      } else {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-january`)?.classList.remove("show");
        nextC = Math.max(1, curC - 1);
        priceEl = document.querySelector(`#cart-wcc-january .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal - itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.remove('active');

      }

      const selectors = [
          '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }

    }, 0);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('wcc-february');
  const product = document.querySelector('.product-info.product-wcc-february');


  if (!checkbox || !product) return;

  checkbox.addEventListener('click', function() {
    setTimeout(() => {
      if (this.checked) {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-february`)?.classList.add("show");
        nextC = Math.max(1, curC + 1);
        priceEl = document.querySelector(`#cart-wcc-february .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal + itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.add('active');
      } else {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-february`)?.classList.remove("show");
        nextC = Math.max(1, curC - 1);
        priceEl = document.querySelector(`#cart-wcc-february .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal - itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.remove('active');

      }

      const selectors = [
          '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-may',
            '.product-info.product-wcc-june',
            '.product-info.product-wcc-july',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }

    }, 0);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('wcc-march');
  const product = document.querySelector('.product-info.product-wcc-march');


  if (!checkbox || !product) return;

  checkbox.addEventListener('click', function() {
    setTimeout(() => {
      if (this.checked) {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-march`)?.classList.add("show");
        nextC = Math.max(1, curC + 1);
        priceEl = document.querySelector(`#cart-wcc-march .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal + itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.add('active');
      } else {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-march`)?.classList.remove("show");
        nextC = Math.max(1, curC - 1);
        priceEl = document.querySelector(`#cart-wcc-march .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal - itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.remove('active');

      }

      const selectors = [
          '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-may',
            '.product-info.product-wcc-june',
            '.product-info.product-wcc-july',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }

    }, 0);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('wcc-april');
  const product = document.querySelector('.product-info.product-wcc-april');


  if (!checkbox || !product) return;

  checkbox.addEventListener('click', function() {
    setTimeout(() => {
      if (this.checked) {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-april`)?.classList.add("show");
        nextC = Math.max(1, curC + 1);
        priceEl = document.querySelector(`#cart-wcc-april .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal + itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.add('active');
      } else {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-april`)?.classList.remove("show");
        nextC = Math.max(1, curC - 1);
        priceEl = document.querySelector(`#cart-wcc-april .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal - itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.remove('active');

      }

      const selectors = [
          '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }

    }, 0);
  });
});




document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('wcc-may');
  const product = document.querySelector('.product-info.product-wcc-may');


  if (!checkbox || !product) return;

  checkbox.addEventListener('click', function() {
    setTimeout(() => {
      if (this.checked) {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-may`)?.classList.add("show");
        nextC = Math.max(1, curC + 1);
        priceEl = document.querySelector(`#cart-wcc-may .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal + itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.add('active');
      } else {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-may`)?.classList.remove("show");
        nextC = Math.max(1, curC - 1);
        priceEl = document.querySelector(`#cart-wcc-may .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal - itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.remove('active');

      }

      const selectors = [
          '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-may',
            '.product-info.product-wcc-june',
            '.product-info.product-wcc-july',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }

    }, 0);
  });
});





document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('wcc-june');
  const product = document.querySelector('.product-info.product-wcc-june');


  if (!checkbox || !product) return;

  checkbox.addEventListener('click', function() {
    setTimeout(() => {
      if (this.checked) {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-june`)?.classList.add("show");
        nextC = Math.max(1, curC + 1);
        priceEl = document.querySelector(`#cart-wcc-june .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal + itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.add('active');
      } else {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-june`)?.classList.remove("show");
        nextC = Math.max(1, curC - 1);
        priceEl = document.querySelector(`#cart-wcc-june .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal - itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.remove('active');

      }

      const selectors = [
          '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-may',
            '.product-info.product-wcc-june',
            '.product-info.product-wcc-july',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }

    }, 0);
  });
});





document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('wcc-july');
  const product = document.querySelector('.product-info.product-wcc-july');


  if (!checkbox || !product) return;

  checkbox.addEventListener('click', function() {
    setTimeout(() => {
      if (this.checked) {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-july`)?.classList.add("show");
        nextC = Math.max(1, curC + 1);
        priceEl = document.querySelector(`#cart-wcc-july .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal + itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.add('active');
      } else {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-july`)?.classList.remove("show");
        nextC = Math.max(1, curC - 1);
        priceEl = document.querySelector(`#cart-wcc-july .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal - itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.remove('active');

      }

      const selectors = [
          '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-may',
            '.product-info.product-wcc-june',
            '.product-info.product-wcc-july',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }

    }, 0);
  });
});





document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('wcc-wallpapers');
  const product = document.querySelector('.product-info.product-wcc-wallpapers');


  if (!checkbox || !product) return;

  checkbox.addEventListener('click', function() {
    setTimeout(() => {
      if (this.checked) {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-wallpapers`)?.classList.add("show");
        nextC = Math.max(1, curC + 1);
        priceEl = document.querySelector(`#cart-wcc-wallpapers .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal + itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.add('active');
      } else {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-wcc-wallpapers`)?.classList.remove("show");
        nextC = Math.max(1, curC - 1);
        priceEl = document.querySelector(`#cart-wcc-wallpapers .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal - itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.remove('active');

      }

      const selectors = [
          '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-may',
            '.product-info.product-wcc-june',
            '.product-info.product-wcc-july',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }

    }, 0);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('ecchitoons');
  const product = document.querySelector('.product-info.product-ecchitoons');

  if (!checkbox || !product) return;

  checkbox.addEventListener('click', function() {
    setTimeout(() => {
      if (this.checked) {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;


        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-ecchitoons`)?.classList.add("show");
        nextC = Math.max(1, curC + 1);
        priceEl = document.querySelector(`#cart-ecchitoons .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal + itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.add('active');
      } else {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;


        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-ecchitoons`)?.classList.remove("show");
        nextC = Math.max(1, curC - 1);
        priceEl = document.querySelector(`#cart-ecchitoons .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal - itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.remove('active');

      }

     const selectors = [
        '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-may',
            '.product-info.product-wcc-june',
            '.product-info.product-wcc-july',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }

    }, 0);
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('waifu-collection');
  const product = document.querySelector('.product-info.product-waifu-collection');

  if (!checkbox || !product) return;

  checkbox.addEventListener('click', function() {
    setTimeout(() => {
      if (this.checked) {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-waifu-collection`)?.classList.add("show");
        nextC = Math.max(1, curC + 1);
        priceEl = document.querySelector(`#cart-waifu-collection .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal + itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.add('active');
      } else {
        let counter = document.getElementById("counter-cart");
        let curC = parseInt(counter.textContent, 10) || 0;
        let nextC = curC;

        let totalCartEl = document.querySelector('#total-cart');
        let priceEl;
        let currentTotal = parseFloat(totalCartEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        let itemPrice = 0;
        let newTotal = currentTotal;
        document.querySelector(`#cart-waifu-collection`)?.classList.remove("show");
        nextC = Math.max(1, curC - 1);
        priceEl = document.querySelector(`#cart-waifu-collection .qty-col h3[data-price]`);
        itemPrice = parseFloat(priceEl.getAttribute('data-price')) || 0;
        newTotal = currentTotal - itemPrice;

        counter.textContent = nextC;
        totalCartEl.textContent = '$' + newTotal.toFixed(2)

        product.classList.remove('active');

      }

     const selectors = [
         '.product-info.product-40cards-safe',
            '.product-info.product-40cards-lewd',
            '.product-info.product-40cards-both',
            '.product-info.product-binder-safe',
            '.product-info.product-binder-lewd',
            '.product-info.product-binder-both',
            '.product-info.product-double-safe',
            '.product-info.product-double-both',
            '.product-info.product-wcc-september',
            '.product-info.product-wcc-october',
            '.product-info.product-wcc-november',
            '.product-info.product-wcc-december',
            '.product-info.product-wcc-january',
            '.product-info.product-wcc-february',
            '.product-info.product-wcc-march',
            '.product-info.product-wcc-april',
            '.product-info.product-wcc-may',
            '.product-info.product-wcc-june',
            '.product-info.product-wcc-july',
            '.product-info.product-wcc-wallpapers',
            '.product-info.product-ecchitoons',
            '.product-info.product-waifu-collection'
        ];

        const anyActive = selectors.some(sel => 
          document.querySelector(sel)?.classList.contains('active')
        );

        if (anyActive) {
          document.querySelector('#checkout-btn').textContent = "Add Selected & Continue";
        } else {
          document.querySelector('#checkout-btn').textContent = "I'll Leave";
        }

    }, 0);
  });
});



// WCC Monthly
document.querySelector('#cart-wcc-monthly .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-monthly');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.wcc-monthly')?.classList.remove('active');
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// WCC Quarterly
document.querySelector('#cart-wcc-quarterly .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-quarterly');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.wcc-quarterly')?.classList.remove('active');
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// WCC Six Months
document.querySelector('#cart-wcc-six-months .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-six-months');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.wcc-six-months')?.classList.remove('active');
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// WCC Annual
document.querySelector('#cart-wcc-annual .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-annual');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.wcc-annual')?.classList.remove('active');
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// TOB Monthly
document.querySelector('#cart-tob-monthly .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-tob-monthly');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('#tob-step .product-info')?.classList.remove('active');
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// TOB Quarterly
document.querySelector('#cart-tob-quarterly .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-tob-quarterly');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('#tob-step .product-info')?.classList.remove('active');
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// TOB Six Months
document.querySelector('#cart-tob-six-months .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-tob-six-months');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
   document.querySelector('#tob-step .product-info')?.classList.remove('active');
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// TOB Annual
document.querySelector('#cart-tob-annual .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-tob-annual');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('#tob-step .product-info')?.classList.remove('active');
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// Waifu Cards Safe
document.querySelector('#cart-waifu-cards-safe .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-waifu-cards-safe');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-40cards-safe')?.classList.remove('active');
    document.getElementById('sfw-cards').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// Waifu Cards Ecchi
document.querySelector('#cart-waifu-cards-ecchi .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-waifu-cards-ecchi');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-40cards-lewd')?.classList.remove('active');
    document.getElementById('nsfw-cards').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// Waifu Cards Both
document.querySelector('#cart-waifu-cards-both .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-waifu-cards-both');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-40cards-both')?.classList.remove('active');
    document.getElementById('both-cards').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// Binder Safe
document.querySelector('#cart-binder-safe .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-binder-safe');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-binder-safe')?.classList.remove('active');
    document.getElementById('sfw-binder').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// Binder Ecchi
document.querySelector('#cart-binder-ecchi .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-binder-ecchi');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-binder-lewd')?.classList.remove('active');
    document.getElementById('nsfw-binder').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// Binder Both
document.querySelector('#cart-binder-both .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-binder-both');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-binder-both')?.classList.remove('active');
    document.getElementById('both-binder').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});


// Double Safe
document.querySelector('#cart-double-safe .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-double-safe');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-double-safe')?.classList.remove('active');
    document.getElementById('sfw-double').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// Double Both
document.querySelector('#cart-double-both .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-double-both');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-double-both')?.classList.remove('active');
    document.getElementById('both-double').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// WCC September
document.querySelector('#cart-wcc-september .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-september');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-wcc-september')?.classList.remove('active');
    document.getElementById('wcc-september').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// WCC October
document.querySelector('#cart-wcc-october .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-october');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-wcc-october')?.classList.remove('active');
    document.getElementById('wcc-october').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// WCC November
document.querySelector('#cart-wcc-november .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-november');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-wcc-november')?.classList.remove('active');
    document.getElementById('wcc-november').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// WCC December
document.querySelector('#cart-wcc-december .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-december');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-wcc-december')?.classList.remove('active');
    document.getElementById('wcc-december').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// WCC January
document.querySelector('#cart-wcc-january .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-january');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-wcc-january')?.classList.remove('active');
    document.getElementById('wcc-january').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// WCC February
document.querySelector('#cart-wcc-february .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-february');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-wcc-february')?.classList.remove('active');
    document.getElementById('wcc-february').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// WCC March
document.querySelector('#cart-wcc-march .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-march');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-wcc-march')?.classList.remove('active');
    document.getElementById('wcc-march').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// WCC April
document.querySelector('#cart-wcc-april .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-april');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-wcc-april')?.classList.remove('active');
    document.getElementById('wcc-april').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// WCC May
document.querySelector('#cart-wcc-may .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-may');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-wcc-may')?.classList.remove('active');
    document.getElementById('wcc-may').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// WCC June
document.querySelector('#cart-wcc-june .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-june');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-wcc-june')?.classList.remove('active');
    document.getElementById('wcc-june').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// WCC July
document.querySelector('#cart-wcc-july .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-july');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-wcc-july')?.classList.remove('active');
    document.getElementById('wcc-july').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});


// WCC Wallpapers
document.querySelector('#cart-wcc-wallpapers .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-wcc-wallpapers');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-wcc-wallpapers')?.classList.remove('active');
    document.getElementById('wcc-wallpapers').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});

// EcchiToons
document.querySelector('#cart-ecchitoons .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-ecchitoons');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-ecchitoons')?.classList.remove('active');
    document.getElementById('ecchitoons').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});


// Waifu Collection
document.querySelector('#cart-waifu-collection .remove-item')?.addEventListener('click', function() {
  let box = document.getElementById('cart-waifu-collection');
  if (box) {
    box.classList.remove('show');
    let price = parseFloat(box.querySelector('.qty-col h3[data-price]')?.getAttribute('data-price')) || 0;
    let totalEl = document.getElementById('total-cart');
    if (totalEl) {
      let total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) || 0;
      totalEl.textContent = '$' + Math.max(0, (total - price)).toFixed(2);
    }
    document.querySelector('.product-info.product-waifu-collection')?.classList.remove('active');
    document.getElementById('waifu-collection').checked = false;
    let counter = document.getElementById("counter-cart");
    if (counter) {
      let curC = parseInt(counter.textContent, 10) || 0;
      counter.textContent = Math.max(0, curC - 1);
    }
  }
});